import { uiNotify } from "../../actions";


export const CATEGORIES_LOADED = "CATEGORIES_LOADED";

export const getCategories = (param) => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  if(!param) param = "*"

  const ES_URL = `/api/es/catalog/${param}`;
  const PT_URL = `/api/pt/catalog/${param}`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL)
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Categories loaded" }));

      return dispatch({
        type: CATEGORIES_LOADED,
        payload: {
          data: data,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};

